"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

require("./Menu.css");

var _MenuButton = require("../Buttons/MenuButton");

var _SettingsButton = require("../Buttons/SettingsButton");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Menu = _ref => {
  let {
    children,
    onCloseClickOverride,
    shouldCloseOnClick,
    transitionTime = 300,
    zIndex = 2,
    color,
    bgColor,
    menuBgColor,
    backdropColor = '#e3e6e850',
    settings,
    renderButton,
    className,
    fullSlider,
    fader,
    left
  } = _ref;
  const [show, setShow] = (0, _react.useState)(false);
  let button;
  if (renderButton) button = renderButton(show, setShow, transitionTime, color, bgColor);else {
    const Button = settings ? _SettingsButton.SettingsButton : _MenuButton.MenuButton;
    button = /*#__PURE__*/_react.default.createElement(Button, {
      className: "button ".concat(left ? 'left' : ''),
      open: !!(show || onCloseClickOverride),
      setOpen: v => {
        if (onCloseClickOverride) onCloseClickOverride();else setShow(v);
      },
      transitionTime: transitionTime,
      stageDelay: transitionTime * .3,
      color: color,
      backgroundColor: bgColor,
      styles: {
        zIndex: zIndex + 2,
        backgroundColor: bgColor
      }
    });
  }
  let container;
  const style = {
    zIndex: zIndex + 1,
    color,
    backgroundColor: menuBgColor !== null && menuBgColor !== void 0 ? menuBgColor : bgColor
  };
  if (fader) container = /*#__PURE__*/_react.default.createElement("div", {
    className: "xburgerMenu fader ".concat(show ? ' show' : '', " ").concat(className),
    onClick: e => shouldCloseOnClick && shouldCloseOnClick(e) && setShow(false),
    style: _objectSpread(_objectSpread({}, style), {}, {
      transition: "opacity ".concat(transitionTime, "ms ease-out")
    })
  }, children);else container = /*#__PURE__*/_react.default.createElement("div", {
    className: "xburgerMenu slider ".concat(fullSlider ? '' : 'partial', " ").concat(show ? ' show' : '', " ").concat(left ? 'left' : '', " ").concat(className),
    onClick: e => shouldCloseOnClick && shouldCloseOnClick(e) && setShow(false),
    style: _objectSpread(_objectSpread({}, style), {}, {
      transition: "left ".concat(transitionTime, "ms ease-out, right ").concat(transitionTime, "ms ease-out")
    })
  }, children);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !fullSlider && !fader && /*#__PURE__*/_react.default.createElement("div", {
    className: "xburgerTouchOutsideSensor ".concat(show ? ' show' : ''),
    onClick: () => setShow(false),
    style: {
      transition: "opacity ".concat(transitionTime, "ms ease-out"),
      zIndex,
      backgroundColor: backdropColor
    }
  }), button, container);
};

exports.Menu = Menu;